package com.shadowings.gero.data.lessons.chapter9

import com.shadowings.gero.data.lessons.buildAdverbialPhoneticKeyboardQuizzes
import com.shadowings.gero.data.lessons.buildAdverbialTextTranslationQuizzes
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_tutto_insieme_ora_1
import gero.composeapp.generated.resources.exp_content_tutto_insieme_ora_2
import gero.composeapp.generated.resources.exp_content_tutto_insieme_ora_3
import gero.composeapp.generated.resources.exp_title_tutto_insieme_ora
import kotlin.random.Random

fun getTuttoInsiemeOraContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_tutto_insieme_ora,
            content = Res.string.exp_content_tutto_insieme_ora_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_tutto_insieme_ora,
            content = Res.string.exp_content_tutto_insieme_ora_2,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_tutto_insieme_ora,
            content = Res.string.exp_content_tutto_insieme_ora_3,
            face = Faces.Happy,
            character = Characters.Masko,
        )
    )
}

fun getTuttoInsiemeOraQuizContent(
    words: List<Word>,
    languageCode: String,
    adverbialSentencesTsvContent: String? = null
): List<IQuizContent> {
    val translationQuizzes = buildAdverbialTextTranslationQuizzes(
        random = Random,
        words = words,
        languageCode = languageCode,
        count = 7
    )
    val keyboardQuizzes = buildAdverbialPhoneticKeyboardQuizzes(
        random = Random,
        words = words,
        languageCode = languageCode,
        count = 3
    )
    return (translationQuizzes + keyboardQuizzes).shuffled()
}
